export default {
    resalesLanding: {
        sentOn: "Отправлено",
        toggleContact: "Показать/скрыть контакты агентства",
        propertyOffers: "Предложения недвижимости",
        openGallery: "Открыть галерею фото",
        prevPhoto: "Предыдущее фото",
        nextPhoto: "Следующее фото",
        close: "Закрыть",
        photo: "Фото",
        description: "Описание",
        more: "Ещё",
        less: "Свернуть",
        intFloorSpace: "Полезная площадь",
        build: "Застроенная площадь",
        terrace: "Терраса",
        garden: "Сад",
        buildYear: "Год постройки",
        fees: "Расходы",
        communityFees: "Плата за обслуживание",
        basuraTax: "Налог на вывоз мусора (Basura)",
        ibiFees: "IBI (налог на недвижимость)",
        securityDeposit: "Залог",
        perMonth: "/месяц",
        perWeek: "/неделя",
        disclaimer: "Отказ от ответственности",
        energyCertificate: "Энергетический сертификат",
        pending: "В ожидании",
        rating: "Класс",
        presentedBy: "Представлено",
        propertyDetails: "Характеристики объекта",
        reference: "Номер объекта",
        referenceShort: "Реф",
        unitUnavailable: "Больше недоступно",
        availableUnits: "Доступные объекты и цены",
        availableUnitsShort: "Доступные объекты",
        unit: "Объект",
        type: "Тип",
        floors: "Этажи",
        bedrooms: "Спальни",
        bathrooms: "Ванные",
        surfaceArea: "Внутренняя",
        price: "Цена",
        status: "Статус",
        unitAvailable: "Доступен",
        unitReserved: "Забронирован",
        unitSold: "Продан",
        seeMore: "Показать ещё",
        seeLess: "Показать меньше",
        floor: "Этаж",
        storeys: "Количество этажей",
        keyReady: "Готов к заселению",
        touristLicence: "Туристическая лицензия",
        firstOccupationLicence: "Разрешение на первое заселение",
        notKnown: "Не указано",
        notProvided: "Не предоставлено",
        yes: "Да",
        no: "Нет",
        mortgageAvailable: "Возможна ипотека",
        guaranteedRental: "Гарантированная аренда",
        sellBeforeCompletion: "Уступка договора до завершения строительства",
        sellBeforeCompletionYes: "Разрешена",
        sellBeforeCompletionNo: "Не разрешена",
        sellBeforeCompletionNotProvided: "Не предоставлено",
        reservation: "Бронирование",
        contract: "Договор",
        construction: "Строительство",
        completion: "Завершение",
        co2: "CO2",
        energyConsumption: "Энергопотребление",
        co2PerYear: "кг CO2/год",
        kwhPerYear: "кВт·ч/год",
        features: "Характеристики",
        viewDetails: "Показать детали",
        hideDetails: "Скрыть характеристики объекта",
        backToResults: "Результаты",
        viewProperty: "Посмотреть объект",
        prevProperty: "Предыдущая",
        nextProperty: "Следующая",
        viewAllFeatures: "Показать все характеристики",
        allFeatures: "Все характеристики",
        infoOnRequest: "Информация по запросу",
        tbc: "Уточн.",
        featureCategoryLabels: { pool: "Бассейн", views: "Вид", parking: "Парковка", kitchen: "Кухня", condition: "Состояние", garden: "Сад" },
        featureQualifierFormat: "{value} {category}",
        location: "Расположение",
        agencyInformation: "Информация об агентстве",
        buyingCosts: "Расходы на покупку",
        propertyPrice: "Цена объекта:",
        priceNote: "**Цена не включает налоги и расходы на покупку.",
        estimatedPurchaseCosts: "Ориентировочные расходы на покупку:",
        hide: "Скрыть",
        showBreakdown: "Показать расшифровку расходов на покупку",
        purchaseCostBreakdown: "Расшифровка расходов на покупку",
        concept: "Статья",
        application: "Применение",
        rowTransferTax: "ITP (налог на передачу собственности, вторичное жильё)",
        rowVat: "НДС (новостройка)",
        rowVatLand: "НДС",
        vatApplication: "10 % (4 % для социального жилья)",
        rowStampDuty: "Гербовый сбор (AJD)",
        rowNotary: "Нотариус",
        rowLandRegistry: "Реестр собственности",
        officialTariff: "Официальный тариф",
        costRangeNotePrefix: "*Общие расходы покупателя обычно составляют от",
        and: "до",
        ofPurchasePrice: "от цены покупки.",
        costApproxNote: "*Ориентировочные расходы на покупку приведены только для справки. Фактические расходы могут отличаться в зависимости от объекта и обстоятельств покупателя. Для точного расчёта рекомендуем обратиться за профессиональной консультацией.",
        additionalInformation: "Дополнительная информация",
        addInfoDocument: "*Сокращённый информационный документ доступен в соответствии с андалузским декретом 218/2005",
        addInfoNoFees: "*Покупатель не платит комиссию агентства недвижимости",
        formHeading: "Хотите узнать больше о ценах и объекте?",
        firstName: "Имя",
        enterNumber: "Введите номер",
        email: "Эл. почта",
        searchCountry: "Поиск страны или кода",
        noMatches: "Совпадений нет",
        consent: "Нажимая кнопку, вы даёте согласие на обработку своих персональных данных в соответствии с политикой конфиденциальности, включая сбор, хранение и использование предоставленной информации для связи с вами и предоставления необходимых сведений.",
        send: "Отправить",
        contactUs: "Связаться с нами",
        yourMessage: "Ваше сообщение",
        agreeData: "Я согласен предоставить свои данные для получения ответа на мой запрос информации.",
        agreeContact: "Я прошу предоставить информацию и согласен на то, чтобы компания, ответственная за проект, или соответствующий продавец связались со мной по контактным данным, которые я добровольно предоставляю для этой цели.",
        reject: "Отклонить",
        like: "Нравится",
        liked: "Сохранено",
        rejected: "Отклонено",
        offerRejected: "Предложение отклонено",
        contact: "Контакт",
        call: "Позвонить",
        calling: "Звонок",
        noPhone: "Телефон недоступен",
        enquirySent: "Запрос отправлен — мы свяжемся",
        yourDetails: "ваши данные",
        respondedTo: "обработано",
        noProperties: "Нет объектов для отображения.",
        soldOutBody: "Объекты из этого предложения проданы или сняты с продажи. Пожалуйста, свяжитесь с агентством, чтобы получить обновлённую подборку.",
        expiredTitle: "Срок действия этой ссылки истёк",
        expiredBody: "Пожалуйста, свяжитесь с агентством, чтобы получить актуальную ссылку для просмотра этих объектов.",
        unavailableTitle: "Предложение недоступно",
        unavailableBody: "Не удалось загрузить это предложение. Возможно, ссылка недействительна или сервис временно недоступен — попробуйте позже или свяжитесь с агентством.",
    },
    title: "Свойства {agencyName}",
    in: "in",
    propertiesFound: "свойства найдены",
    toDay: "Сегодня",
    days: "дни",
    week: "Неделя",
    year: "Год",
    month: "Месяц",
    prev: "Предыдущая",
    next: "Далее",
    backToList: "Вернуться к списку",
    sorry: "Извините, мы",
    cantFind: "не могу найти",
    lookingFor: "страница, которую вы ищете ...",
    thankYou: "СПАСИБО ЗА ПОСЕЩЕНИЕ НАШЕГО ВЕБ-САЙТА",
    pleaseContact: "Пожалуйста, свяжитесь с агентом для получения нового URL.",
    ForSale: "ПРОДАЖА",
    ShortTermRental: "Краткосрочная аренда",
    LongTermRental: "Долгосрочная аренда",
    showMore: "Показать больше",
    showLess: "Показать меньше",
    price: "Цена",
    pricePer: "Цена за",
    built: "Сборка",
    floorSpace: "Интерьер площадь",
    terrace: "Терраса",
    garden: "Сад",
    plot: "Сюжет",
    propTitle: '{subType} {searchType} в {location}',
    propTitleShort: '{subType} в {location}',
    notAvailable: "Недоступно",
    notFound: 'Страница не найдена',
    emptyProperties: "Ничего не найдено. Свяжитесь с вашим агентом для получения дополнительной информации.",
    linkExpired: "К сожалению, эта ссылка истекла. Свяжитесь со своим агентом по недвижимости, чтобы получить обновленную ссылку на недвижимость.",
    newDevelopment: "Новая разработка",
    agencyRaiiNo: "Регистрационный номер агентства",
    home: {
        verifyYourURLHere: "Подтвердите здесь свой URL. Для этого войдите в WhatsApp в своем веб-браузере, затем скопируйте URL-адрес из WhatsApp сюда.",
        pasteUrlHere: "Вставить URL сюда",
        verifyUrl: "Подтвердить URL",
        whatIsPropertyViewer: "Что такое Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Этот веб-сайт используется агентами по недвижимости для отправки объектов недвижимости своим клиентам. Это продукт {resalesonlinecom}. В случае сомнений обращайтесь к Агент, который отправил вам список вашего имущества",
        howDoesItWork: "Как это работает?",
        inThePast: "В прошлом агенты присылать PDF-документы своим клиентам. Тем не менее, это не легко просматривать на многих устройствах. Поэтому мы создали {propertyviewercom}, чтобы клиенту было легче просматривать свойства, отправленные им.",
        createAShortList: "Агент создаст краткий список свойств. Когда они поделятся этими свойствами с вами, вы получите ссылку. Нажав на эту ссылку покажет вам свойства."
    },

    list: {
        propertyTitle: "Нажмите здесь, чтобы просмотреть информацию для этого свойства"
    },

    searchType: {
        ForSale: "на продажу",
        ShortTermRental: "в краткосрочную аренду",
        LongTermRental: "в долгосрочную аренду",
    },

    rsStatus: {
        Available: "Доступный",
        Listing: "Распечатка",
        UnderOffer: "В предложении",
        SaleAgreed: "Продажа согласована",
        OffMarket: "Вне рынка",
        Sold: "Продавать",
        Rented: "Арендованный"
    },

    details: {
        average: "Средний",
        averagePricesFor: "Средние цены для",
        showFullER: "Показать полностью",
        thisProperty: "Это свойство",
        infoNotAvailable: "Эта информация недоступна.",
        feesEnergyRating: "Комиссия за энергопотребление",
        fees: "Сборы",
        ibiFees: "Взносы IBI",
        basuraTax: "Налог на басуру",
        communityFees: "Коммунальные сборы",
        associatedCosts: "Сопутствующие расходы",
        energyRating: "	Рейтинг энергоэффективности",
        securityDeposit: "Залог за сохранность имущества",
        energyCertificate: "Энергетический сертификат",
        energyCertificatePending: "Энергетический сертификат ожидает рассмотрения",
        energyConsumption: "Энергопотребление",
        co2: "CO₂",
        co2PerYear: "кгCO₂/м² в год",
        kwhPerYear: "кВтч/м² в год",
        other: "Другие",
        buildYear: "Год выпуска",
        forSale: "Продажа",
        sold: "Продано",
        longTerm: "Долгосрочный",
        shortTermHigh: "Кратковременный максимум",
        shortTermLow: "Краткосрочный минимум",
        allFeatures: "Все функции",
        aproxLocation: "Примерное местоположение",
        listingAgent: "Listing agent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Номер туристической регистрации",
        agencyInformation: "Информация об агентстве",
    },
};